import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: 'app-mattooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class MatTooltipComponent {

}
